import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonIcon,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonSpinner,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import type { RefresherCustomEvent } from '@ionic/react';
import { shirtOutline } from 'ionicons/icons';
import { useNavigate } from 'react-router-dom';
import { AppSectionHeader } from '../../components/ui/AppSectionHeader';
import { MatchList } from '../../main-tabs/competition/components/MatchList';
import { MatchWeekSelector } from '../../main-tabs/competition/components/MatchWeekSelector';
import { useMatchWeekSelection } from '../../main-tabs/competition/hooks/useMatchWeekSelection';

export const MatchWeeksManagementPage = () => {
  const navigate = useNavigate();
  const matchWeekSelection = useMatchWeekSelection();
  const { data, loading, error, refetch } = matchWeekSelection.matchesQuery;
  const matchWeekMatches = data?.getMatches;

  const onRefresh = async (ev: RefresherCustomEvent) => {
    try {
      await refetch();
    } finally {
      ev.detail.complete();
    }
  };

  return (
    <IonPage>
      <AppSectionHeader variant="admin">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/app/admin" text="" aria-label="Volver" />
          </IonButtons>
          <IonTitle className="ml-4">Gestión de jornadas</IonTitle>
        </IonToolbar>
      </AppSectionHeader>

      <IonContent>
        <IonRefresher slot="fixed" onIonRefresh={onRefresh}>
          <IonRefresherContent />
        </IonRefresher>
        <MatchWeekSelector selection={matchWeekSelection} />

        {loading && (
          <div className="flex justify-center p-8">
            <IonSpinner />
          </div>
        )}

        {error && (
          <div className="p-4 text-center text-red-600">Error al cargar los datos: {error.message}</div>
        )}

        {!loading && !error && data && !matchWeekMatches && (
          <div className="px-4 py-8 text-center text-slate-500">No hay jornadas registradas por ahora.</div>
        )}

        {matchWeekMatches && (
          <>
            <div className="mx-4 mt-3">
              <IonButton
                expand="block"
                onClick={() => navigate(`/app/admin/jornadas/${matchWeekMatches.currentMatchWeek.id}/once`)}
              >
                <IonIcon icon={shirtOutline} slot="start" />
                11 de la jornada
              </IonButton>
            </div>
            <MatchList matches={matchWeekMatches.matches} matchPathPrefix="/app/admin/jornadas/partidos" />
          </>
        )}
      </IonContent>
    </IonPage>
  );
};
